import { Component, OnInit, ViewChild, AfterContentChecked } from '@angular/core';
import { Producto, ProductoEstado } from '../../../../interfaces/producto';
import { ProductoService } from '../../../../providers/producto.service';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material';
import { Caracteristica } from '../../../../interfaces/caracteristica';
import { TipoProducto } from '../../../../interfaces/tipo-producto';
import { VerArchivosProductoComponent } from '../../../../forms/productos/archivos-producto/ver-archivos-producto/ver-archivos-producto.component';
import { DetalleService, DetalleNombre } from '../../../../providers/detalle.service'; import { CaracteristicaValor } from '../../../../interfaces/valor-caracteristica';


@Component({
  selector: 'app-detalle-producto-pagina',
  templateUrl: './detalle-producto-pagina.component.html',
  styleUrls: ['./detalle-producto-pagina.component.scss']
})
export class DetalleProductoPaginaComponent implements OnInit, AfterContentChecked {
  cargando: boolean = true;
  IdProducto?: number | string;
  producto: Producto;
  tabSelectedIndex: number = 0;

  @ViewChild('archivosProducto') archivosProducto: VerArchivosProductoComponent;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  constructor(
    private route: ActivatedRoute,
    private productoService: ProductoService,
    private detalleService: DetalleService
  ) { }

  ngOnInit() {
    this.producto = new Producto();

    this.route.params.subscribe(params => {
      this.IdProducto = params['id'];
      this.actualizarDetalle();
    });
  }

  ngAfterContentChecked() {
    if (this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.length > 1) {
      this.tabSelectedIndex = this.detalleService.getDetalleTabActivo(DetalleNombre.DETALLE_PRODUCTO);
    }
  }

  // get active tab on change
  selectedTabChange(event: MatTabChangeEvent): void {
    var tabActivo = +event.index;
    this.detalleService.setDetalleTabActivo(DetalleNombre.DETALLE_PRODUCTO, tabActivo);
  }

  actualizarArchivos(): void { // actualizar archivos
    this.archivosProducto.IdProducto = this.IdProducto;
    this.archivosProducto.actualizarTabla();
  }

  actualizarDetalle(): void {
    this.cargando = true;
    this.productoService.getProductos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdProducto: this.IdProducto
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var producto = respuesta.data.productos[0];
          if (producto) {
            this.producto = new Producto(
              producto.IdProducto,
              producto.fechaAlta,
              producto.descripcion,
              producto.stock,
              producto.observaciones,
              !!+producto.web, // "!!+" castea de string a entero y de entero a boolean
              !!+producto.destacado,
              producto.importe,
              !!+producto.importeMostrar,
              <ProductoEstado>{
                IdEstado: producto.estado.id,
                descripcion: producto.estado.desc
              },
              <TipoProducto>{
                id: producto.tipo.id,
                descripcion: producto.tipo.desc
              },
              <Caracteristica[]>[], // blanquear caracteristicas
              !!+producto.descripcionCustom,
              !!+producto.especial
            );

            // guardar los valores de las características seleccionadas para este producto
            if (producto.caracteristicas && producto.caracteristicas.length > 0) {
              producto.caracteristicas.forEach(caracteristica => {
                this.producto.caracteristicas.push(<Caracteristica>{
                  IdCaracteristica: caracteristica.IdCarac,
                  descripcion: caracteristica.caracDesc,
                  seleccionado: <CaracteristicaValor>{
                    IdCaracteristicaValor: caracteristica.IdValor,
                    descripcion: caracteristica.valor
                  }
                });
              });
            }

            this.actualizarArchivos();
          }
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }
}
